var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseSkel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 75,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#aebcc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.572,
    d: "M118.04 1.008H6.96a5.22 5.22 0 0 0-5.22 5.218V68.33a5.22 5.22 0 0 0 5.219 5.218h111.08a5.22 5.22 0 0 0 5.219-5.218V6.226a5.22 5.22 0 0 0-5.219-5.218z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aebcc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.572,
    d: "M13.232 63.41h34.816c.998 0 1.807-.81 1.807-1.807V12.955c0-.999-.81-1.808-1.807-1.808H13.231c-.999 0-1.808.81-1.808 1.808v48.648c0 .998.81 1.807 1.808 1.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aebcc6",
    d: "M30.873 18H16.127a1.2 1.2 0 0 1-.797-.294.95.95 0 0 1-.33-.71.95.95 0 0 1 .334-.705 1.2 1.2 0 0 1 .793-.291h14.746a1.2 1.2 0 0 1 .794.291c.21.187.33.44.333.705a.95.95 0 0 1-.33.71 1.2 1.2 0 0 1-.797.294m-10.271 5h-5.204c-.106 0-.207-.106-.281-.294a2 2 0 0 1-.117-.71 2 2 0 0 1 .118-.705c.074-.186.175-.291.28-.291h5.204c.105 0 .206.105.28.291.075.187.117.44.118.705 0 .266-.042.521-.116.71s-.176.294-.282.294"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#aebcc6",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.6 51.322h2.222v11.2a.8.8 0 0 0 .8.8h21.154a.8.8 0 0 0 .8-.8v-11.2H43.8a.8.8 0 0 0 .528-1.4l-13.6-12a.8.8 0 0 0-1.056 0l-13.6 12a.8.8 0 0 0 .528 1.4m3.022-1.6h-.907L30.2 39.589l11.485 10.133h-.908a.8.8 0 0 0-.8.8v11.2H20.424v-11.2a.8.8 0 0 0-.8-.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6 51.322h2.222v11.2a.8.8 0 0 0 .8.8h21.154a.8.8 0 0 0 .8-.8v-11.2H43.8a.8.8 0 0 0 .528-1.4l-13.6-12a.8.8 0 0 0-1.056 0l-13.6 12a.8.8 0 0 0 .528 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.133 53.723h-4a1.6 1.6 0 0 0-1.6 1.6v6.4a1.6 1.6 0 0 0 1.6 1.6h4a1.6 1.6 0 0 0 1.6-1.6v-6.4a1.6 1.6 0 0 0-1.6-1.6m-4 8v-6.4h4v6.4z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#aebcc6",
    d: "M111.062 63.662h-23.86a1.823 1.823 0 0 1-1.824-1.823A1.824 1.824 0 0 1 87.2 60.03h23.861a1.82 1.82 0 0 1 1.823 1.808 1.823 1.823 0 0 1-1.823 1.823zm0-49.121H61.581a1.823 1.823 0 0 1-1.824-1.823 1.807 1.807 0 0 1 1.824-1.823h49.481a1.805 1.805 0 0 1 1.684 1.112c.092.22.139.457.139.695a1.82 1.82 0 0 1-1.122 1.699c-.222.093-.46.14-.701.14M90.03 26.818H61.58a1.806 1.806 0 0 1-1.823-1.807 1.824 1.824 0 0 1 1.824-1.823h28.45a1.823 1.823 0 0 1 1.684 2.518 1.81 1.81 0 0 1-1.684 1.112zm-9.1 12.368H61.58a1.823 1.823 0 0 1 0-3.647h19.35a1.81 1.81 0 0 1 1.807 1.823 1.81 1.81 0 0 1-1.807 1.824m9.1 12.199H61.58a1.823 1.823 0 0 1-1.683-2.519 1.81 1.81 0 0 1 1.684-1.112h28.45a1.807 1.807 0 0 1 1.823 1.808 1.823 1.823 0 0 1-1.823 1.823z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.955.223h123.089v74.111H.955z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 34h32v32H15z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseSkel);
export default __webpack_public_path__ + "static/media/houseSkel.415531e30d4879d52a686d2f5756f26b.svg";
export { ForwardRef as ReactComponent };